import React from "react"
import {
  Box,
  Button,
  Card,
  CardMedia,
  Paper,
  TextField,
  Typography,
} from "@mui/material"
import SimpleMDE from "react-simplemde-editor"
import "easymde/dist/easymde.min.css"
import styles from "./AddPost.module.scss"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import { createPost, updatePost } from "../../../features/posts/postSlice"

export const AddArticle = ({ currentId, setCurrentId }) => {
  const navigate = useNavigate()
  // const { id } = useParams()
  const { user } = useSelector((state) => state.auth)
  // const post = useSelector((state) =>
  //   currentId ? state.posts.posts.find((p) => p._id === currentId) : null
  // )
  const inputFileRef = React.useRef(null)
  const dispatch = useDispatch()

  const [selectedFile, setSelectedFile] = React.useState()
  const [message, setMessage] = React.useState("")
  const [title, setTitle] = React.useState("")

  const options = React.useMemo(
    () => ({
      spellChecker: false,
      maxHeight: "400px",
      autofocus: true,
      placeholder: "Text",
      status: false,
      autosave: {
        enabled: true,
        delay: 1000,
      },
    }),
    []
  )

  const onChange = React.useCallback((value) => {
    setMessage(value)
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (currentId) {
      const postData = {
        id: currentId,
        title,
        message,
        selectedFile,
        name: user?.result?.name,
      }
      dispatch(updatePost(postData))
    } else {
      const postData = {
        title,
        message,
        selectedFile,
        name: user?.result?.name,
      }
      const data = await dispatch(createPost(postData))
      navigate(`/posts/${data?.payload?._id}`)
    }
  }

  const handleChangeFile = async (e) => {
    try {
      const formData = new FormData()
      formData.append("image", e.target.files[0])
      const { data } = await axios.post(
        `${process.env.REACT_APP_URL}/upload`,
        formData
      )
      setSelectedFile(data.url)
    } catch (error) {
      console.error(error)
      alert("error")
    }
  }
  const onClickRemoveImage = async (selectedFileName) => {
    setSelectedFile("")
    await axios.delete(`${process.env.REACT_APP_URL}/upload`, {
      data: { file: selectedFileName },
    })
  }
  if (!user?.result?.name) {
    return (
      <Paper elevation={6}>
        <Typography variant="h6" align="center" padding={2} fontWeight={300}>
          Please Sign In
          <br />
          to create your own posts
          <br />
          and like other's posts.
        </Typography>
      </Paper>
    )
  }

  return (
    <Paper style={{ padding: 30 }}>
      <Box
        autoComplete="off"
        noValidate
        onSubmit={handleSubmit}
        component="form"
      >
        <Button onClick={() => inputFileRef.current.click()} variant="outlined">
          Download preview
        </Button>
        <input
          ref={inputFileRef}
          type="file"
          onChange={handleChangeFile}
          hidden
        />
        {selectedFile && (
          <>
            <Button
              variant="contained"
              color="error"
              onClick={() =>
                onClickRemoveImage(selectedFile.match(/posts\/(.*)/)[1])
              }
              sx={{ marginLeft: 2 }}
            >
              Delete
            </Button>

            <Card sx={{ maxWidth: 640, marginTop: 3 }}>
              <CardMedia
                sx={{ width: 640, height: 360 }}
                image={`${process.env.REACT_APP_URL}${selectedFile}`}
                title="Uploaded"
                alt="Uploaded"
              />
            </Card>
          </>
        )}

        <br />
        <br />
        <TextField
          classes={{ root: styles.title }}
          variant="standard"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          fullWidth
        />

        <SimpleMDE
          className={styles.editor}
          name="message"
          value={message}
          onChange={onChange}
          options={options}
        />

        <div className={styles.buttons}>
          <Button
            type="submit"
            size="large"
            variant="contained"
            disabled={!title || !message}
          >
            {/* {isEditing ? "Save" : "Опубликовать"} */}submit
          </Button>
          <Button variant="text" onClick={() => navigate(-1)} color="error">
            Cancel
          </Button>
        </div>
      </Box>
    </Paper>
  )
}
